import React, { memo, useContext, useEffect, useState } from "react"
import { Modal, Form } from "react-bootstrap";
import InputGroup from "../component/infutGroup";
import CustomSelect from "../constant/customselect";
import CustomButton from "../component/button";
import { retry } from "@reduxjs/toolkit/query";
import filterApplicant from "../constant/advanceFilter";
import { toastMsg } from "../component/toast";
import { PostCallWithErrorResponse, deleteWithAuthCall, simpleGetCall, simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { optionsSalary } from "../constant/optionSalary";
import { Tooltip } from "antd";
import { educationOptions } from "../constant/educationOpt";
import { personalityTypes } from "../constant/jobType";
import { personaloities } from "../constant/personaloities";
import clear from "../assets/images/claear.svg"
import { formatDate, sortSalaryOptions } from "../common";
import MessageBox from "../component/MessageBox";
import {buildLabel,formatToDDMMYYYY} from "../common";
import InlineTitleEditor from "../component/QuizTitle";
import ChipsInput from "../component/ChipsInput";

 const opt = [
  { value: "Pioneer", label: "Pioneer" },
//   { value: "#ffc235_Pioneer", label: "Pioneer" },
//   { value: "#eb2323_Pioneer", label: "Pioneer" },
//   { value: "#9e9b9b_Pioneer", label: "Pioneer" },

  { value: "Influencer", label: "Influencer" },
//   { value: "#ffc235_Influencer", label: "Influencer" },
//   { value: "#eb2323_Influencer", label: "Influencer" },
//   { value: "#9e9b9b_Influencer", label: "Influencer" },

  { value: "Team Player", label: "Team Player" },
//   { value: "#ffc235_Team Player", label: "Team Player" },
//   { value: "#eb2323_Team Player", label: "Team Player" },
//   { value: "#9e9b9b_Team Player", label: "Team Player" },

  { value: "Logical Thinker", label: "Logical Thinker" },
//   { value: "#ffc235_Logical Thinker", label: "Logical Thinker" },
//   { value: "#eb2323_Logical Thinker", label: "Logical Thinker" },
//   { value: "#9e9b9b_Logical Thinker", label: "Logical Thinker" },

  { value: "Persuader", label: "Persuader" },
//   { value: "#ffc235_Persuader", label: "Persuader" },
//   { value: "#eb2323_Persuader", label: "Persuader" },
//   { value: "#9e9b9b_Persuader", label: "Persuader" },

  { value: "Achiever", label: "Achiever" },
//   { value: "#ffc235_Achiever", label: "Achiever" },
//   { value: "#eb2323_Achiever", label: "Achiever" },
//   { value: "#9e9b9b_Achiever", label: "Achiever" },

  { value: "Perfectionist", label: "Perfectionist" },
//   { value: "#ffc235_Perfectionist", label: "Perfectionist" },
//   { value: "#eb2323_Perfectionist", label: "Perfectionist" },
//   { value: "#9e9b9b_Perfectionist", label: "Perfectionist" },

  { value: "Collaborator", label: "Collaborator" },
//   { value: "#ffc235_Collaborator", label: "Collaborator" },
//   { value: "#eb2323_Collaborator", label: "Collaborator" },
//   { value: "#9e9b9b_Collaborator", label: "Collaborator" },

  { value: "Assessor", label: "Assessor" },
//   { value: "#ffc235_Assessor", label: "Assessor" },
//   { value: "#eb2323_Assessor", label: "Assessor" },
//   { value: "#9e9b9b_Assessor", label: "Assessor" },

  { value: "Implementor", label: "Implementor" },
//   { value: "#ffc235_Implementor", label: "Implementor" },
//   { value: "#eb2323_Implementor", label: "Implementor" },
//   { value: "#9e9b9b_Implementor", label: "Implementor" },

  { value: "Motivator", label: "Motivator" },
//   { value: "#ffc235_Motivator", label: "Motivator" },
//   { value: "#eb2323_Motivator", label: "Motivator" },
//   { value: "#9e9b9b_Motivator", label: "Motivator" },

  { value: "Leader", label: "Leader" },
//   { value: "#ffc235_Leader", label: "Leader" },
//   { value: "#eb2323_Leader", label: "Leader" },
//   { value: "#9e9b9b_Leader", label: "Leader" },

  { value: "Administrator", label: "Administrator" },
//   { value: "#ffc235_Administrator", label: "Administrator" },
//   { value: "#eb2323_Administrator", label: "Administrator" },
//   { value: "#9e9b9b_Administrator", label: "Administrator" },

  { value: "Mediator", label: "Mediator" },
//   { value: "#ffc235_Mediator", label: "Mediator" },
//   { value: "#eb2323_Mediator", label: "Mediator" },
//   { value: "#9e9b9b_Mediator", label: "Mediator" },

  { value: "All Rounder", label: "All Rounder" },
//   { value: "#ffc235_All Rounder", label: "All Rounder" },
//   { value: "#eb2323_All Rounder", label: "All Rounder" },
//   { value: "#9e9b9b_All Rounder", label: "All Rounder" },
];

const options = [
    { label: "Greater Than", value: "Greater Than" },
    { label: "Less Than", value: "Less Than" },
    { label: "Between", value: "Between" }
]

const AdvanceFilter = (props) => {

    const { adminData } = useContext(AppContext)

    let initial = {
        isOpen: false,
        id: 0
    }

    const [isDeleteFilter, setIsDeleteFilter] = useState(initial)

    const [filterName, setFilterName] = useState('Untitled Filter')

    const [isUpdateFilter, setIsUpdateFilter] = useState(false)

    const {
        applicatnts,
        show,
        customQuestion,
        setAccessCoeList,
        setShowAdvanceFilter,
        setIsFilter,
        isClearFilters,
        setIsClearFilters,
        setFilteredInfo,
        code,
        setFilteredData,
        allData,
        setIsTableFilteredApplied,
        setSelects,
        setSelectsRec,
        isShort=false

    } = props


    const initialState = {
        id: 0,
        filterName: '',
        personalityMatch: [],
        profileMatch: [],
        educationLevel: [],
        educationArea: [],
        industry: [],
        currentTitle: [],
        experience: "",
        expAbo: "",
        expBel: '',
        exprienceIn: 'Between',
        prmeryIn: 'Between',
        secnIn: 'Between',
        departments: [],
        availDateBef: '',
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        question6: '',
        graph1: [],
        graph2: [],
        graph3: [],
        primaryPersonlity: "",
        primaryPerAbo: '',
        primaryPErBel: '',
        secoundryPersonlity: '',
        secoundryPersonlityAbo: '',
        secoundryPersonlityBel: '',
        quizScore: [],
        expectedSal: []

    }

    const dropDownsDetails = {
        personalities: [],
        profiles: [],
        educationLevels: [],
        eductionArea: [],
        industries: [],
        departments: [],
        quizScores: [],
        graph1: [],
        graph2: [],
        graph3: [],
        titleList: [],
        salOpt: [],
        currentCompany: [],
        locations : [],
        currentSalary: [],
        applicationDate: [],
        tags: []

    }

    const [filters, setFilters] = useState(initialState)
    const [isAddFilter, setISAddFilter] = useState(false)
    const [dropdownData, setDropDownData] = useState(dropDownsDetails)
    const [filterList, stFilterList] = useState([])

    const handleChange = (key, val) => {

        setFilters(prev => ({
            ...prev,
            [key]: val
        }))

    }

    const clearFilters = () => {

        setFilters(initialState)
        setAccessCoeList(allData)
        // setShowAdvanceFilter(false)
        setFilteredInfo({})
        setIsTableFilteredApplied(false)
        setSelects([])
        setSelectsRec([])
    }


    useEffect(() => {

        if (isClearFilters) {
            clearFilters()
            setIsClearFilters(false)
        }

    }, [isClearFilters])

    useEffect(() => {
        getDropDownData()
        getFilters()

    }, [show])

    useEffect(() => {
        getAllIndustryList()
        getAllspecialization()
        getDepartmentList()
    }, [])






    const getDropDownData = () => {


        const makeOptions = (arr) =>
            [...new Set(arr.filter(Boolean))].map((val) => ({
                label: val,
                value: val,
            }));

        const personalities = makeOptions(applicatnts.map((a) => a?.personalityMatch));
        const profiles = makeOptions(applicatnts.map((a) => a?.applicationMatch));
        const educationLevels = makeOptions(applicatnts.map((a) => a?.educationLevel));


        const quizScores = makeOptions(applicatnts.map((a) => a?.quizScore));
        const emptyLast = (options) => [
            ...options.filter((opt) => String(opt?.label ?? "").trim()),
            ...options.filter((opt) => !String(opt?.label ?? "").trim()),
        ];

        const graph1 = emptyLast(makeOptions(applicatnts.map((a) => buildLabel(a?.profile_1_Fitment_Color, a?.profile_1, a?.preD_D))));
        const graph2 = emptyLast(makeOptions(applicatnts.map((a) => buildLabel(a?.profile_2_Fitment_Color, a?.profile_2, a?.preD_M))));
        const graph3 = emptyLast(makeOptions(applicatnts.map((a) => buildLabel(a?.profile_3_Fitment_Color, a?.profile_3, a?.preD_L))));
        const titleList = makeOptions(applicatnts.map((a) => a?.roleName));
        const salOpt = makeOptions(applicatnts.map((a) => a?.expectedCTC));

        const currentCompany = makeOptions(applicatnts.map((a) => a?.currentCompany));
        const locations = makeOptions(applicatnts.map((a) => a?.currentLocation));
        const currentSalary = makeOptions(applicatnts.map((a) => a?.currentSalary));
        const applicationDate= makeOptions(applicatnts.map((a) => formatToDDMMYYYY(a?.dateOfCompletion)));
        
        let tags = makeOptions(applicatnts.map((a) => a?.tags?.map((tag) => tag?.status)).flat())

        console.log(locations,tags);
        
        const sortedCurrentSalary = sortSalaryOptions(currentSalary)
        const sortedSalOpt = sortSalaryOptions(salOpt)

        setDropDownData(prev => ({
            ...prev,
            personalities,
            profiles,
            educationLevels,
            quizScores,
            graph1,
            graph2,
            graph3,
            titleList,
            salOpt: sortedSalOpt,
            currentCompany,
            locations,
            currentSalary: sortedCurrentSalary,
            applicationDate,
            tags
        }));
    };


    const getDepartmentList = () => {
        simpleGetCall(ApiConfig.GET_DEPARTMENT_LIST)
            .then((res) => {
                if (res.succeded) {
                    setDropDownData(prev => ({
                        ...prev,
                        departments: res?.response
                    }))
                }
            })


    }

    const getAllIndustryList = () => {
        simpleGetCall(ApiConfig.GET_INDUSTRY_LIST)
            .then((res) => {
                if (res.succeded) {
                    setDropDownData(prev => ({
                        ...prev,
                        industries: res?.response
                    }))
                }
            })
            .catch((err) => console.log(err));
    };

    const getAllspecialization = () => {
        simpleGetCall(ApiConfig.GET_AREA_OF_EDUCATION)
            .then((res) => {
                if (res.succeded) {
                    setDropDownData(prev => ({
                        ...prev,
                        eductionArea: res?.response
                    }));
                }
            })

    };

    const handleSaveFilter = (isNew = true) => {

        if (filterName?.length < 3) {
            toastMsg('error', 'Please Enter Filter Name At Least 3 Words')
            return
        }

        let data = {}

        if (!isNew) {
            data.id = filters?.id || 0
        }



        data.email = adminData?.email
        data.code = code
        data.filterJson = JSON.stringify(filters)
        data.filterName = filterName

        PostCallWithErrorResponse(ApiConfig.SAVE_ADVANCE_FILTER, data).then((res) => {

            if (res?.json?.succeded) {
                toastMsg('success', res?.json?.response?.statusMessage)
                setISAddFilter(false)
                setIsUpdateFilter(false)

                if (filters.id === 0) {
                    setFilterName('Untitled Filter')
                }



                getFilters()
            } else {
                toastMsg('error', res?.json?.response?.statusMessage)
            }

        })

    }

    const getFilters = () => {

        simpleGetCallWithErrorResponse(ApiConfig.GET_FILTERS_LIST + `?Code=${code}&EmailId=${adminData?.email}`).then((res) => {


            if (res?.json?.succeded) {
                let option = res?.json?.response?.map((i) => ({
                    label: i?.filterName,
                    value: i?.id,
                    details: i
                }))


                stFilterList(option)

            }




        })

    }

    const handleAboveBelowValid = () => {

        const primaryAbove = Number(filters?.primaryPerAbo || 0);
        const primaryBelow = Number(filters?.primaryPErBel || 0);
        const secondaryAbove = Number(filters?.secoundryPersonlityAbo || 0);
        const secondaryBelow = Number(filters?.secoundryPersonlityBel || 0);
        const expAbove = Number(filters?.expAbo || 0);
        const expBelow = Number(filters?.expBel || 0);


        if (
            (filters?.primaryPerAbo && filters?.primaryPErBel && primaryBelow < primaryAbove) ||
            (filters?.secoundryPersonlityAbo && filters?.secoundryPersonlityBel && secondaryBelow < secondaryAbove) ||
            (filters?.expAbo && filters?.expBel && expBelow <= expAbove)
        ) {
            toastMsg('error', 'Please Enter Below Value Greater Than Above');
            return false;
        }

        return true;
    };


    const handleDeleteFilter = (id, data) => {

        console.log(data);

        setIsDeleteFilter({
            isOpen: true,
            id,
            filterName: data?.label
        })

    }

    const handleDeleteFilterApi = () => {


        deleteWithAuthCall(ApiConfig.DELETE_FILTER + `${isDeleteFilter.id}`).then((res) => {

            if (res?.succeded) {
                filters?.id === isDeleteFilter.id && setFilters(initialState)
                toastMsg('success', res?.response?.statusMessage)
                getFilters()
                setIsDeleteFilter(initial)
            } else {
                toastMsg('error', res?.response?.statusMessage)
            }

        })

    }


    return (
        <>
            <Modal show={show}
                centered
                onHide={() => {
                    setShowAdvanceFilter(false)
                    clearFilters()
                    setFilterName('Untitled Filter')
                }}
                size="lg"
                dialogClassName="custom-modal-height"
            >
                <Modal.Header closeButton className="custom-close-btn align-items-center">
                    <h6 className="mb-0 flex-shrink-0" style={{ width: '120px' }}>Advanced Filter</h6>
                    <Form.Group className="align-items-center mb-0 d-flex flex-grow-1" style={{ width: '100%', marginLeft: '20px' }} controlId="exampleForm.ControlInput1">
                            {/* <Form.Label className="job_size mb-0 flex-shrink-0 me-2 mt-1">Filter Name</Form.Label> */}

                            <div className="flex-grow-1 mt-1 filter-name-select" style={{ width: '100%' }}>
                                <CustomSelect
                                    value={filters?.id}
                                    isBottomBorderOnFocus={true}
                                    options={filterList}
                                    labelKey='label'
                                    valKey='value'
                                    isDeleteOption={true}
                                    // isMulti={true}
                                    size={"small"}
                                    placeholder="Untitled Filter"
                                    handleDeleteFilter={handleDeleteFilter}
                                    handleChange={(e, data) => {


                                        setFilters(JSON.parse(data?.details?.details?.filterJson) || {})

                                        setFilterName(data?.label)

                                        setFilters(prev => ({
                                            ...prev,
                                            id: e,
                                            filterName: data?.label
                                        }))

                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '400px', maxHeight: '750px', overflow: 'auto' }}>
                    <Form>
                        <Form.Group className="row align-items-center mb-0" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0">Education Level</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={educationOptions}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Education Level"
                                    value={filters?.educationLevels}
                                    handleChange={(e) => {
                                        handleChange('educationLevels', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-0" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0">Education Area</Form.Label>
                            <div className="col-md-9">
                                {/* <div className="d-flex flex-row flex-wrap align-items-center gap-2">
                                    {filters?.educationArea?.map((i, index) => (
                                        <div
                                            key={index}
                                            className="chips d-inline-flex font-size-13px"
                                        >
                                            {i} <span className="ms-1 fw-bolder" style={{ fontSize: 'var(--font-size-h3)' }}
                                                onClick={() => handleRemove(index, 'educationArea')}
                                            >
                                                ×</span>
                                        </div>
                                    ))}
                                </div> */}
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData?.eductionArea}
                                    labelKey='specializationName'
                                    valKey='specializationName'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Education Area"
                                    value={filters?.educationArea}
                                    handleChange={(e) => {
                                        handleChange('educationArea', e)
                                    }}
                                    isClearaAble={false}
                                />
                                {/* <Form.Control
                                    type="text"
                                    placeholder="Press Enter To Add"
                                    className="bottomBorderField"
                                    value={searchTermsVal?.educationAreaVal}
                                    onChange={(e) => setsearchTermsVal(prev => ({
                                        ...prev,
                                        educationAreaVal: e.target.value
                                    }))}
                                    onKeyDown={(e) => handleKeyDown(e, 'educationArea', 'educationAreaVal')}

                                /> */}


                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-0" >
                            <Form.Label className="job_size col-md-3 mb-0">Industry</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.industries}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    placeholder="Industry"

                                    size={"small"}
                                    value={filters?.industry}
                                    handleChange={(e) => {
                                        handleChange('industry', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-0" >
                            <Form.Label className="job_size col-md-3 mb-0">Current Title</Form.Label>
                            <div className="col-md-9" >
                                <ChipsInput
                                    value={filters?.currentTitle || []}
                                    onChange={(chips) => handleChange('currentTitle', chips)}
                                />
                            </div>
                        </Form.Group>
                         <Form.Group className="row align-items-center mb-0 mt-1" >
                            <Form.Label className="job_size col-md-3 mb-0">Current Company</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.currentCompany}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    placeholder="Current Company"

                                    size={"small"}
                                    value={filters?.currentCompany}
                                    handleChange={(e) => {
                                        handleChange('currentCompany', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-1 mt-1">
                            <Form.Label className="job_size col-md-3 mb-0">Experience</Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                {/* <InputGroup
                                        l1="Above"
                                        l2="Below"
                                        l3="Yrs"
                                        placeholder1="0"
                                        placeholder2="50"
                                        value1={filters?.expAbo}
                                        value2={filters?.expBel}
                                        key1="expAbo"
                                        key2='expBel'
                                        handleChange={(key, val) => {

                                            if (key === "expBel" && val > 50) return;

                                            handleChange(key, val)
                                        }}
                                        validated={filters?.expAbo && filters?.expBel && Number(filters.expAbo) >= Number(filters.expBel)}
                                    /> */}





                                {/* Above Label */}
                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0">Above</Form.Label>
                                </div>

                                {/* Above Input */}
                                <div className="col-md-2">
                                    <Form.Control
                                        style={{ width: "100%" }}
                                        type="number"
                                        value={filters?.expAbo}
                                        className="bottomBorderField col-md-8"
                                        onChange={(e) => handleChange("expAbo", e.target.value)}
                                    />
                                </div>

                                {/* Year Label (After Above) */}
                                <div className="col-md-1">
                                    <span className="job_size col-md-3 mb-0">Year</span>
                                </div>

                                {/* Below Label */}
                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0">Below</Form.Label>
                                </div>

                                {/* Below Input */}
                                <div className="col-md-2">
                                    <Form.Control
                                        style={{ width: "100%" }}
                                        type="number"
                                        value={filters?.expBel}
                                        className={`bottomBorderField col-md-8 ${filters?.expAbo && filters?.expBel && Number(filters.expAbo) > Number(filters.expBel)
                                            ? 'bottomBorderFieldInvalid'
                                            : ''
                                            }`}
                                        onChange={(e) => handleChange("expBel", e.target.value)}
                                    />
                                </div>

                                {/* Year Label (After Below) */}
                                <div className="col-md-1">
                                    <span className="job_size col-md-3 mb-0">Year</span>
                                </div>

                                {/* Cross Icon at End of Row */}
                                {(filters?.expAbo || filters?.expBel) && (
                                    <div className="col-md-4 d-flex justify-content-end" style={{ marginLeft: '-10px' }}>
                                        <img
                                            src={clear} // your cross icon
                                            alt="Clear"
                                            style={{
                                                height: "18px",
                                                width: "18px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() =>
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    expAbo: '',
                                                    expBel: '',
                                                }))
                                            }
                                        />
                                    </div>
                                )}

                            </div>

                        </Form.Group>
                        <Form.Group className="row align-items-center mb-1" >
                            <Form.Label className="job_size col-md-3 mb-0">Department</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.departments}
                                    labelKey='name'
                                    valKey='name'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Department"
                                    value={filters?.departments}
                                    handleChange={(e) => {
                                        handleChange('departments', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>

                         <Form.Group className="row align-items-center mb-1" >
                            <Form.Label className="job_size col-md-3 mb-0">Location</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.locations}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Location"
                                    value={filters?.locations}
                                    handleChange={(e) => {
                                        handleChange('locations', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>


                        <Form.Group className="row align-items-center mb-1">
                            <Form.Label className="job_size col-md-3 mb-0">Available Before & App. Date</Form.Label>

                            <div className="col-md-5 position-relative">
                                <Form.Control
                                    type="date"
                                    placeholder="Available Before"
                                    className={`bottomBorderField custom-placeholder pe-4 ${filters?.availDateBef ? "" : "date-empty"}`}
                                    style={{ paddingRight: "35px", minHeight: '32px' }}
                                    value={filters?.availDateBef || ""}
                                    onChange={(e) => handleChange("availDateBef", e.target.value)}
                                />
                                {filters?.availDateBef && (
                                    <img
                                        src={clear}
                                        alt="Clear"
                                        className="position-absolute top-50 translate-middle-y"
                                        style={{ right: "40px", cursor: "pointer", width: "14px", height: "14px", zIndex: 2 }}
                                        onClick={() => handleChange("availDateBef", "")}
                                    />
                                )}
                            </div>

                            <div className="col-md-4 position-relative">
                                <Form.Control
                                    type="date"
                                    placeholder="Application Date"
                                    className={`bottomBorderField custom-placeholder pe-4 ${filters?.applicationDate ? "" : "date-empty"}`}
                                    style={{ paddingRight: "35px", minHeight: '32px' }}
                                    value={filters?.applicationDate || ""}
                                    onChange={(e) => handleChange("applicationDate", e.target.value)}
                                />
                                {filters?.applicationDate && (
                                    <img
                                        src={clear}
                                        alt="Clear"
                                        className="position-absolute top-50 translate-middle-y"
                                        style={{ right: "40px", cursor: "pointer", width: "14px", height: "14px", zIndex: 2 }}
                                        onClick={() => handleChange("applicationDate", "")}
                                    />
                                )}
                                {/* <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData?.applicationDate}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Application Date"
                                    value={filters?.applicationDate}
                                    handleChange={(e) => handleChange('applicationDate', e)}
                                    isClearaAble={false}
                                    hasMappedOpt={true}
                                /> */}
                            </div>
                        </Form.Group>


                        <Form.Group className="row align-items-center mb-1">
                            <Form.Label className="job_size col-md-3 mb-0">Current & Expected Salary</Form.Label>

                            <div className="col-md-5">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.currentSalary}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Current Salary"
                                    value={filters?.currentSalary}
                                    handleChange={(e) => {
                                        handleChange('currentSalary', e)
                                    }}
                                    isClearaAble={false}
                                />
                            </div>

                            <div className="col-md-4">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData?.salOpt}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Salary Expectation"
                                    value={filters?.expectedSal}
                                    handleChange={(e) => handleChange('expectedSal', e)}
                                    isClearaAble={false}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="row align-items-center mb-1" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0">
                                Quiz Score</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.quizScores}
                                    labelKey='label'
                                    valKey='value'
                                    placeholder={"Quiz Score"}
                                    isMulti={true}
                                    size={"small"}
                                    value={filters?.quizScore}
                                    handleChange={(e) => {
                                        handleChange('quizScore', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        


                                    <Form.Group className="row align-items-center mb-1">
                                        <div className="col-md-3">
                                                <Form.Label className="job_size mb-0 ">
                                                    BuyOut Option
                                                </Form.Label>
                                        </div>

                                        <div className="col-md-9 d-flex align-items-center flex-nowrap" >
                                            

                                            <div className="d-flex align-items-center flex-shrink-0" style={{ width: '110px' }}>
                                                {["Yes", "No"].map((option) => (
                                                    <Form.Check
                                                        inline
                                                        key={option}
                                                        type="radio"
                                                        name="buyOut"
                                                        label={option}
                                                        value={option}
                                                        className="me-3 mb-0 font-size-11px"
                                                        style={{ minHeight: 0 }}
                                                        checked={filters?.buyOut === option}
                                                        onChange={(e) => handleChange('buyOut', e.target.value === filters?.buyOut ? "" : e.target.value)}
                                                    />
                                                ))}
                                            </div>

                                            <div
                                                className="d-flex align-items-center justify-content-end align-self-center flex-shrink-0"
                                                style={{ width: '30px', paddingRight: '12px', lineHeight: 0 }}
                                            >
                                                {filters?.buyOut && (
                                                    <img
                                                        src={clear}
                                                        alt="Clear"
                                                        style={{ height: '16px', width: '16px', cursor: 'pointer', display: 'block' }}
                                                        onClick={() => handleChange('buyOut', '')}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </Form.Group>
                        {/* <Form.Group className="row align-items-center mb-0 mt-0" >
                            <Form.Label className="job_size col-md-3 mb-0">Primary Personality</Form.Label>

                            <div className="col-md-9 d-flex align-items-center">


                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0">Above</Form.Label>
                                </div>
                                <div className="col-md-2">
                                    <Form.Control
                                        style={{ width: '100%' }}
                                        type='number'
                                        value={filters?.primaryPerAbo}

                                        className="bottomBorderField col-md-8"
                                        onChange={(e) => {
                                            if (e.target.value <= 100)
                                                handleChange('primaryPerAbo', e.target.value)
                                        }}
                                    />


                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0"
                                    >
                                        %
                                    </span>
                                </div>

                                <div className="col-md-1" style={{ marginLeft: '-25px' }}>
                                    <Form.Label className="job_size col-md-3 mb-0">Below</Form.Label>
                                </div>
                                <div className="col-md-2">
                                    <div style={{ position: "relative", width: "100%" }}>
                                        <Form.Control
                                            style={{ width: "100%", paddingRight: "25px" }} // padding-right so text doesn't overlap with %
                                            type="number"
                                            value={filters?.primaryPErBel}
                                            className={`bottomBorderField col-md-8 ${filters?.primaryPerAbo && filters?.primaryPErBel && Number(filters.primaryPerAbo) > Number(filters.primaryPErBel)
                                                ? 'bottomBorderFieldInvalid'
                                                : ''
                                                }`}

                                            onChange={(e) => {
                                                if (e.target.value <= 100) handleChange("primaryPErBel", e.target.value)
                                            }}
                                        />


                                    </div>

                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0"
                                    >
                                        %
                                    </span>
                                </div>

                            </div>
                        </Form.Group> */}
                        {/* <Form.Group className="row align-items-center mb-0 mt-1" >
                            <Form.Label className="job_size col-md-3 mb-0">
                                Secondary Personality</Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                

                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0">Above</Form.Label>
                                </div>
                                <div className="col-md-2">
                                    <div>
                                        <Form.Control
                                            style={{ width: '100%' }}
                                            type='number'
                                            value={filters?.secoundryPersonlityAbo}

                                            className="bottomBorderField col-md-8"
                                            onChange={(e) => {
                                                if (e.target.value <= 100) handleChange('secoundryPersonlityAbo', e.target.value)
                                            }
                                            }
                                        />


                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0"
                                    >
                                        %
                                    </span>
                                </div>
                                <div className="col-md-1" style={{ marginLeft: '-25px' }}>
                                    <Form.Label className="job_size col-md-3 mb-0">Below</Form.Label>
                                </div>
                                <div className="col-md-2">

                                    <div style={{ position: "relative", width: "100%" }}>
                                        <Form.Control
                                            style={{ width: '100%' }}
                                            type='number'
                                            value={filters?.secoundryPersonlityBel}

                                            className={`bottomBorderField col-md-8 ${filters?.secoundryPersonlityBel && filters?.secoundryPersonlityAbo && Number(filters.secoundryPersonlityAbo) > Number(filters.secoundryPersonlityBel)
                                                ? 'bottomBorderFieldInvalid'
                                                : ''
                                                }`}
                                            onChange={(e) => {
                                                if (e.target.value <= 100) handleChange('secoundryPersonlityBel', e.target.value)
                                            }
                                            }
                                        />


                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0"
                                    >
                                        %
                                    </span>
                                </div>
                                <div className="col-md-4 d-flex justify-content-end" style={{ marginLeft: '13px' }}>
                                    {
                                        (filters?.secoundryPersonlityBel || filters?.secoundryPersonlityAbo) &&
                                        <img
                                            src={clear}
                                            alt="Clear"
                                            style={{

                                                height: "15px",
                                                width: "15px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() =>
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    secoundryPersonlityBel: '',
                                                    secoundryPersonlityAbo: "",
                                                }))
                                            }
                                        />
                                    }
                                </div>

                                
                            </div>
                        </Form.Group> */}

                        {
                            ['Work Role', 'Natural Self', 'Overall Personality']?.map((graph, index) => {

                                let key = 'graph' + (index + 1)

                                let aboveKey = key + 'Abo'

                                let belowKey = key + 'Bel'

                                console.log(key);

                                if(isShort && graph != 'Work Role') return null;

                                return <>
                                    <Form.Group className="row align-items-center mb-1" controlId="exampleForm.ControlInput1">
                                        <Form.Label className="job_size col-md-3 mb-0">{graph} {graph!='Overall Personality'&&`(Personalities)`}</Form.Label>
                                        <div className="col-md-9 " >
                                            <CustomSelect
                                                isBottomBorder={true}
                                                options={dropdownData?.[key]}
                                                labelKey='label'
                                                valKey='value'
                                                placeholder={graph}
                                                isMulti={true}
                                                size={"small"}

                                                value={filters[key]}
                                                handleChange={(e,data) => {
                                                    console.log(e,data);
                                                    
                                                    handleChange(key, e)
                                                }}
                                                isClearaAble={false}
                                                showColorDot={true}
                                                hasMappedOpt={true}
                                            />

                                        </div>
                                        <div>

                                        </div>
                                    </Form.Group>

                                </>
                            })
                        }
                        <Form.Group className="row align-items-center mb-0" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0">Overall Fitment</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    value={filters?.overall_Fitment_Category}
                                    isBottomBorder={true}
                                    options={personalityTypes}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Overall Fitment"
                                    handleChange={(e) => {
                                        handleChange('overall_Fitment_Category', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>


                        {/* {
                            ['Work Role', 'Natural Self', 'Overall Personality']?.map((graph, index) => {

                                let key = 'graph' + (index + 1)

                                let aboveKey = key + 'Abo'

                                let belowKey = key + 'Bel'



                                if(isShort && graph != 'Work Role') return null;
                                console.log(key);

                                return <>
                                    <Form.Group className="row align-items-center mb-0" controlId="exampleForm.ControlInput1">
                                        <Form.Label className="job_size col-md-3 mb-0">{graph} (Rating)</Form.Label>
                                        <div className="col-md-9 " >

                                            <div className="d-flex align-items-center mb-1">
                                                <div className="col-md-1">
                                                    <Form.Label className="job_size col-md-3 mb-0">Above</Form.Label>
                                                </div>
                                                <div className="col-md-2">
                                                    <div>
                                                        <Form.Control
                                                            style={{ width: '100%' }}
                                                            type='number'
                                                            value={filters[aboveKey]}

                                                            className="bottomBorderField col-md-8"
                                                            onChange={(e) => {
                                                                if (e.target.value <= 100) handleChange(aboveKey, e.target.value)
                                                            }
                                                            }
                                                        />


                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <span
                                                        className="job_size col-md-3 mb-0"
                                                    >
                                                        %
                                                    </span>
                                                </div>
                                                <div className="col-md-1" style={{ marginLeft: '-25px' }}>
                                                    <Form.Label className="job_size col-md-3 mb-0">Below</Form.Label>
                                                </div>
                                                <div className="col-md-2">

                                                    <div style={{ position: "relative", width: "100%" }}>
                                                        <Form.Control
                                                            style={{ width: '100%' }}
                                                            type='number'
                                                            value={filters[belowKey]}

                                                            className={`bottomBorderField col-md-8 ${filters[belowKey] && filters[aboveKey] && Number(filters[aboveKey]) > Number(filters[belowKey])
                                                                ? 'bottomBorderFieldInvalid'
                                                                : ''
                                                                }`}
                                                            onChange={(e) => {
                                                                if (e.target.value <= 100) handleChange(belowKey, e.target.value)
                                                            }
                                                            }
                                                        />


                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <span
                                                        className="job_size col-md-3 mb-0"
                                                    >
                                                        %
                                                    </span>
                                                </div>
                                                <div className="col-md-4 d-flex justify-content-end" style={{ marginLeft: '13px' }}>
                                                    {
                                                        (filters[belowKey] || filters[aboveKey]) &&
                                                        <img
                                                            src={clear}
                                                            alt="Clear"
                                                            style={{

                                                                height: "15px",
                                                                width: "15px",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                                setFilters((prev) => ({
                                                                    ...prev,
                                                                    [belowKey]: '',
                                                                    [aboveKey]: "",
                                                                }))
                                                            }
                                                        />
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                        <div>

                                        </div>
                                    </Form.Group>
                                </>
                            })
                        } */}

                        <Form.Group className="row align-items-center mb-2" >
                                        <Form.Label className="job_size col-md-3 mb-0">Assign Tags</Form.Label>
                                        <div className="col-md-9 " >
                                            <CustomSelect
                                                isBottomBorder={true}
                                                options={dropdownData?.tags}
                                                labelKey='label'
                                                valKey='value'
                                                placeholder={"Assign Tags"}
                                                isMulti={true}
                                                size={"small"}

                                                value={filters?.assingTags}
                                                handleChange={(e,data) => {
                                                    console.log(e,data);
                                                    
                                                    handleChange('assingTags', e)
                                                }}
                                                isClearaAble={false}
                                                hasMappedOpt={true}
                                            />

                                        </div>
                                        <div>

                                        </div>
                                    </Form.Group>

                                    {
                            customQuestion?.slice(0, 6)?.map((i, index) => {
                                if (!i?.questionText) return null;
                                let key = "question" + (index + 1);

                                return (
                                    <Form.Group key={index} className="row align-items-center mb-1">
                                        <div className="col-md-9">
                                            <Tooltip title={i?.questionText} placement="top">
                                                <Form.Label className="job_size mb-0 text-truncate flex-grow-1">

                                                     {i?.questionText}
                                                </Form.Label>
                                            </Tooltip>
                                        </div>

                                        <div className="col-md-3 d-flex align-items-center flex-nowrap" >
                                            {/* <Tooltip title={i?.questionText} placement="top">
                                                <p
                                                    className="mb-0 text-truncate flex-grow-1"
                                                    style={{ minWidth: 0, marginRight: '12px' }}
                                                >
                                                    {i?.questionText}
                                                </p>
                                            </Tooltip> */}

                                            <div className="d-flex align-items-center flex-shrink-0" style={{ width: '110px' }}>
                                                {["Yes", "No"].map((option) => (
                                                    <Form.Check
                                                        inline
                                                        key={option}
                                                        type="radio"
                                                        id={`${key}-${option}`}
                                                        name={key}
                                                        label={option}
                                                        value={option}
                                                        className="me-3 mb-0 font-size-11px"
                                                        style={{ minHeight: 0 }}
                                                        checked={filters[key] === option}
                                                        onChange={(e) => handleChange(key, e.target.value === filters[key] ? "" : e.target.value)}
                                                    />
                                                ))}
                                            </div>

                                            <div
                                                className="d-flex align-items-center justify-content-end align-self-center flex-shrink-0"
                                                style={{ width: '30px', paddingRight: '12px', lineHeight: 0 }}
                                            >
                                                {filters[key] && (
                                                    <img
                                                        src={clear}
                                                        alt="Clear"
                                                        style={{ height: '16px', width: '16px', cursor: 'pointer', display: 'block' }}
                                                        onClick={() => handleChange(key, '')}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </Form.Group>
                                );
                            })
                        }

                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton
                        title='Clear All'
                        buttonType='tertiory'
                        handleClick={
                            clearFilters}
                    />
                    <CustomButton
                        title='Save'
                        buttonType='secondary'
                        handleClick={() => {
                            if (handleAboveBelowValid()) {

                                if (filters?.id > 0) {

                                    setFilterName(filters?.filterName || 'Untitled Filter')

                                    setIsUpdateFilter(true)
                                    return
                                }
                                setISAddFilter(true)
                            }
                        }
                        }
                    />
                    <CustomButton
                        title='Apply'
                        handleClick={() => {
                            if (handleAboveBelowValid()) {
                                setIsFilter(true)
                                let list = filterApplicant(applicatnts, filters)

                                setAccessCoeList(list)
                                setShowAdvanceFilter(false)
                            }
                        }}

                    />
                </Modal.Footer>


            </Modal>

            <Modal show={isAddFilter}
                centered
                onHide={() => {
                    setISAddFilter(false)
                }}
                size="md"
                dialogClassName="modal-h-650"
            >
                <Modal.Header closeButton className="custom-close-btn">
                    <h6 className="mb-0 mt-1">Save New Filter </h6>
                </Modal.Header>
                <Modal.Body >
                    <Form>
                        <Form.Group className="" >
                            <Form.Label className="job_size col-md-3 mb-0">Name</Form.Label>

                            <InlineTitleEditor
                            value={filterName}
                            onSave={(e) => setFilterName(e)}
                            defaultTitle={'Untitled Filter'}
                            />
                            

                        </Form.Group>

                        <div className="d-flex mt-3 justify-content-end">

                            <div className="d-flex gap-1" >
                                <CustomButton
                                    title={"Cancel"}
                                    buttonType='secondary'
                                    handleClick={(e) => setISAddFilter(false)}

                                />

                                <CustomButton
                                    title={"Save"}
                                    handleClick={() => {

                                        handleSaveFilter(true)
                                    }}
                                />
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal
                show={isDeleteFilter.isOpen}
                centered
                onHide={() => setIsDeleteFilter(initial)}
                size="md"

            >
                <Modal.Header closeButton className="custom-close-btn">

                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p className="text-center">
                            Please Confirm if you want to delete {isDeleteFilter?.filterName} filter?
                        </p>
                    </div>
                    <div className="d-flex justify-content-center gap-1">
                        <CustomButton
                            title='No'
                            buttonType='secondary'
                            handleClick={() => setIsDeleteFilter(initial)}
                        />
                        <CustomButton
                            title='Yes'
                            handleClick={handleDeleteFilterApi}
                        // isLoading={isDeleteLoading}
                        />
                    </div>
                </Modal.Body>



            </Modal>

            <Modal
                show={isUpdateFilter}
                centered
                onHide={() => setIsUpdateFilter(false)}
                size="md"

            >
                <Modal.Header closeButton className="custom-close-btn">

                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p className="text-center">
                            Apply changes to existing filter?
                        </p>
                    </div>
                    <div className="d-flex justify-content-center gap-1">
                        <CustomButton
                            title='No'
                            buttonType='secondary'
                            handleClick={() => {
                                setFilterName('Untitled Filter')
                                setIsUpdateFilter(false)
                                setISAddFilter(true)
                            }}
                        />
                        <CustomButton
                            title='Yes'
                            handleClick={() => handleSaveFilter(false)}
                        // isLoading={isDeleteLoading}
                        />
                    </div>
                </Modal.Body>



            </Modal >

        </>
    )

}


export default memo(AdvanceFilter)